<template>
  <c-tab
    v-if="popupParam.ramTechniqueCd === 'RT00000040'"
    type="horizon"
    :tabItems="tabItems"
    :inlineLabel="true"
    :height="tabHeight"
    v-model="tab"
    dense
  >
    <template v-slot:default="tab">
      <component
        :is="tab.component"
        :popupParam="param"
        :assessPlan.sync="assessPlan"
        :attachInfo.sync="attachInfo"
        :imprTabInfo.sync="imprTabInfo"
        :disabled.sync="disabled"
        :contentHeight="tabHeight"
        @getDetail="getDetail"
        @keySetting="keySetting"
        @closePopup="closePopup"
        @loadAssess="loadAssess"
      />
    </template>
  </c-tab>
  <c-step
    v-else
    stepperGrpCd="RAM_RISK_STEP_CD"
    :currentStepCd="popupParam.ramStepCd"
    :param="param"
    v-model="ramStepCd"
    @stepBystep="stepBystep"
    @keySetting="keySetting"
    @research="research"
    @stepClick="stepClick"
    @closePopup="closePopup"
  >
  </c-step>
</template>

<script>
import { uid } from "quasar";
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskDetail",
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        ramRiskAssessmentPlanId: "",
        ramStepCd: "",
        vendorFlag: false,
        ramTechniqueCd: "",
        officeCompleteFlag: "",
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      tab: "info",
      assessPlan: {
        ramRiskAssessmentPlanId: "", // 평가 일련번호
        plantCd: "", // 사업장 코드
        ramTechniqueCd: null, // 평가기법 코드
        ramAssessTypeCd: null, // 평가구분_최초/정기/수시
        assessmentName: "", // 평가명
        assessmentStartDate: "", // 평가시작일
        assessmentEndDate: "", // 평가종료일
        assessmentPeriod: [],
        assessmentYear: "", // 평가년도
        ramStepCd: "", // 평가 진행단계 코드
        deptCd: "", // 평가부서
        deptName: "",
        assessmentManageDeptCd: "", // 평가주관 부서 코드
        assessmentManageUserId: "", // 평가주관 담당자 ID
        remark: "", // 상세내용
        officeCompleteFlag: "",
        jobCategoryCd: null,
        approvalStatusCd: "", // 결재관련 결재상태
        sysApprovalRequestId: "", // 결재관련 결재요청코드
        regUserId: "", // 작성자 ID
        chgUserId: "", // 수정자 ID
        regUserName: "",
        regDtStr: "",
        scenarios: [], // 시나리오 목록
        relatedDocuments: [], // 관련자료 목록
      },
      attachInfo: {
        isSubmit: "",
        taskClassCd: "RISK_PLAN",
        taskKey: "",
      },
      detailUrl: "",
      editable: true,
      ramStepCd: "",
      searchRiskReduce: {
        flag: "",
        isSearch: false,
      },
      searchScenario: {
        flag: "",
        isSearch: false,
      },
      planUpdateBtnData: {
        title: "LBLPLAN",
        flag: false,
        research: "",
        planResearch: "",
      },
    };
  },
  watch: {
    "popupParam.ramStepCd"() {
      this.setStep();
    },
  },
  computed: {
    param() {
      return {
        ramRiskAssessmentPlanId: this.popupParam.ramRiskAssessmentPlanId,
        ramStepCd: this.popupParam.ramStepCd,
        vendorFlag: this.popupParam.vendorFlag,
        ramTechniqueCd: this.popupParam.ramTechniqueCd,
        searchRiskReduce: {
          flag: this.searchRiskReduce.flag,
          isSearch: this.searchRiskReduce.isSearch,
        },
        searchScenario: {
          flag: this.searchScenario.flag,
          isSearch: this.searchScenario.isSearch,
        },
        planUpdateBtnData: this.planUpdateBtnData,
        isApprContent: Boolean(this.popupParam.isApprContent),
      };
    },
    isOld() {
      return Boolean(this.popupParam.ramRiskAssessmentPlanId);
    },
    tabItems() {
      let items = [
        {
          name: "info",
          icon: "info",
          label: "평가",
          component: () => import(`${"./riskOfficeInfo.vue"}`),
        },
      ];
      if (this.isOld) {
        // 저장된 평가인 경우에만 개선 탭 표시
        items.push({
          name: "improvement",
          icon: "error_outline",
          label: "개선",
          component: () => import(`${"@/pages/common/ibm/imprTab.vue"}`),
        });
      }
      return items;
    },
    disabled() {
      return this.assessPlan.officeCompleteFlag === "Y";
    },
    tabHeight() {
      let height = Number(String(this.contentHeight).replace("px", ""));
      if (isNaN(height)) height = 600;
      return height - 40 + "px";
    },
    imprTabInfo() {
      return {
        key: this.popupParam.ramRiskAssessmentPlanId,
        ibmTaskTypeCd: "ITT0000025",
        ibmTaskUnderTypeCd: "ITTU000045",
        requestContents: `${this.assessPlan.assessmentName} (${this.assessPlan.assessmentStartDate}) ${this.assessPlan.deptName}`,
        disabled: this.disabled,
        isOld: true,
        gridItem: {
          listUrl: "",
          param: null,
          title: "개선사항 목록",
          merge: [
            { index: 0, colName: "categoryFst" },
            { index: 1, colName: "categorySnd" },
          ],
          data: this.$_.filter(this.assessPlan.scenarios, (item) => {
            return Boolean(item.sopImprovementIds);
          }),
          columns: [
            {
              name: "categoryFst",
              field: "categoryFst",
              label: "대분류",
              align: "left",
              style: "width:150px",
              sortable: false,
            },
            {
              name: "categorySnd",
              field: "categorySnd",
              label: "중분류",
              align: "left",
              style: "width:150px",
              sortable: false,
            },
            {
              name: "categoryTrd",
              field: "categoryTrd",
              label: "소분류",
              align: "left",
              style: "width:300px",
              sortable: false,
            },
            {
              name: "riskLevelName",
              field: "riskLevelName",
              label: "위험수준",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            // {
            //   name: "remark",
            //   field: "remark",
            //   label: "개선계획",
            //   align: "left",
            //   style: "width:100px",
            //   sortable: false,
            // },
            {
              name: "riskBookFlag",
              field: "riskBookFlag",
              label: "위험등록부",
              align: "center",
              style: "width:80px",
              sortable: false,
            },
            {
              name: "assessDate",
              field: "assessDate",
              label: "평가일",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
            {
              name: "assessUserName",
              field: "assessUserName",
              label: "평가자",
              align: "center",
              style: "width:100px",
              sortable: false,
            },
          ],
          research: this.research,
        },
        gridOther: {
          title: "항목외 개선 목록",
        },
      };
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      // url setting
      this.detailUrl = selectConfig.ram.assessPlan.get.url;
      // code setting
      // list setting
      this.setStep();
      this.getDetail();
    },
    getDetail() {
      // 사무직 위험성평가만 해당
      if (this.popupParam.ramTechniqueCd !== "RT00000040") return;
      if (this.popupParam.ramRiskAssessmentPlanId) {
        this.$http.url = this.$format(
          this.detailUrl,
          this.popupParam.ramRiskAssessmentPlanId,
        );
        this.$http.type = "GET";
        this.$http.request((_result) => {
          this.$_.extend(this.assessPlan, _result.data);
          this.assessPlan.assessmentPeriod =
            this.assessPlan.assessmentStartDate &&
            this.assessPlan.assessmentEndDate
              ? [
                  this.assessPlan.assessmentStartDate,
                  this.assessPlan.assessmentEndDate,
                ]
              : [];
          if (!this.assessPlan.scenarios) {
            this.$set(this.assessPlan, "scenarios", []);
          }
          this.$emit("setRegInfo", _result.data);
          this.$set(
            this.attachInfo,
            "taskKey",
            this.assessPlan.ramRiskAssessmentPlanId,
          );
        });
      } else {
        this.assessPlan.assessmentYear = this.$comm.getThisYear();
        this.assessPlan.assessmentManageUserId =
          this.$store.getters.user.userId;
        this.assessPlan.assessmentManageDeptCd =
          this.$store.getters.user.deptCd;
        this.assessPlan.ramAssessTypeCd = "RAT0000001"; // 정기
        this.assessPlan.regUserId = this.$store.getters.user.userId;
        this.assessPlan.regUserName = this.$store.getters.user.userName;
        this.assessPlan.regDtStr = this.$comm.getTodayDateTime();
        this.assessPlan.ramTechniqueCd = this.popupParam.ramTechniqueCd;
      }
    },
    loadAssess(ramRiskAssessmentPlanId) {
      // 지난 위험성평가 가져오기 : 선택한 평가의 내용을 신규 평가로 복사
      this.$http.url = this.$format(this.detailUrl, ramRiskAssessmentPlanId);
      this.$http.type = "GET";
      this.$http.request((_result) => {
        let src = _result.data;
        if (!src) return;
        let userId = this.$store.getters.user.userId;
        // 평가 기본정보 (제외 : 평가번호, 평가기간, 완료여부, 결재정보, 등록/수정정보)
        this.$_.extend(
          this.assessPlan,
          this.$_.omit(src, [
            "ramRiskAssessmentPlanId",
            "assessmentStartDate",
            "assessmentEndDate",
            "officeCompleteFlag",
            "officeCompleteFlagName",
            "sysApprovalRequestId",
            "approvalTypeCd",
            "approvalStatusCd",
            "approvalStatusName",
            "regUserId",
            "regUserName",
            "regDt",
            "regDtStr",
            "chgUserId",
            "chgUserName",
            "chgDt",
            "scenarios",
            "relatedDocuments",
          ]),
        );
        this.assessPlan.assessmentPeriod = [];
        // 시나리오 (제외 : 결과번호, 위험등록부, 평가일, 평가번호, 개선정보)
        this.assessPlan.scenarios = this.$_.map(src.scenarios, (item) => {
          return this.$_.extend(
            this.$_.omit(item, [
              "riskOfficeResultId",
              "ramSignificantRiskRegisterId",
              "riskBookFlag",
              "assessDate",
              "ramRiskAssessmentPlanId",
              "assessmentName",
              "deptName",
              "officeCompleteFlag",
              "officeCompleteFlagName",
              "sopImprovementIds",
              "ibmClassCds",
              "ibmStepNames",
              "ibmTooltip",
              "regUserId",
              "chgUserId",
            ]),
            {
              riskOfficeResultId: uid(),
              riskBookFlag: "N",
              assessDate: this.$comm.getToday(),
              editFlag: "C",
              regUserId: userId,
            },
          );
        });
        // 관련자료 (제외 : 평가번호, 관련자료번호)
        this.assessPlan.relatedDocuments = this.$_.map(
          src.relatedDocuments,
          (item) => {
            return this.$_.extend(
              this.$_.omit(item, [
                "ramRiskAssessmentPlanId",
                "ramRelatedDocumentId",
                "regUserId",
                "chgUserId",
              ]),
              {
                ramRelatedDocumentId: uid(),
                editFlag: "C",
                regUserId: userId,
              },
            );
          },
        );
      });
    },
    setStep() {
      /**
       * RRS0000005 RRS0000010 단계는 같은 단계로 취급
       * RRS0000005으로 데이터가 저장되지 않고 RRS0000010으로 저장
       * RRS0000010인 경우 팝업에서는 '평가실행'으로 표시되도록 RRS0000005으로 셋팅
       *  */
      if (this.popupParam.ramStepCd === "RRS0000010") {
        this.ramStepCd = "RRS0000005";
      } else {
        this.ramStepCd = this.$_.clone(this.popupParam.ramStepCd);
      }
    },
    stepBystep(stepCd) {
      this.popupParam.ramStepCd = stepCd;
    },
    keySetting(key) {
      this.popupParam.ramRiskAssessmentPlanId = key;
    },
    research(data) {
      if (data.place === "scenario") {
        this.searchRiskReduce.isSearch = true;
      } else {
        this.searchScenario.isSearch = true;
      }
    },
    stepClick(step) {
      if (step === "RRS0000010" && this.searchRiskReduce.isSearch) {
        this.searchRiskReduce.flag = uid();
        this.searchRiskReduce.isSearch = false;
      } else if (step === "RRS0000005" && this.searchScenario.isSearch) {
        this.searchScenario.flag = uid();
        this.searchScenario.isSearch = false;
      }
    },
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>
